const currencyFormatStyleEnum = {
  CURRENCY: 'currency',
  DECIMAL: 'decimal'
}
/*
 *  currencyDisplay (trecho da documentação)
 *   How to display the currency in currency formatting. The default is "symbol".
 *
 *   "symbol": use a localized currency symbol such as €.
 *   "narrowSymbol": use a narrow format symbol ("$100" rather than "US$100").
 *   "code": use the ISO currency code.
 *   "name": use a localized currency name such as "dollar".
 */
const currencyFormat = (value, style = 'currency', maximumFractionDigits = 2 ,currencyDisplay = 'symbol', currency = 'EUR') => {
  return new Intl.NumberFormat('pt-BR', { style: style, currency: currency, currencyDisplay: currencyDisplay, maximumFractionDigits: maximumFractionDigits }).format(value)
}

// Retorna um número formatado com os pontos. Exemplo: 1.000.000
const formatNumber = (value) => {
  return new Intl.NumberFormat('pt-BR').format(value)
}

// * Formata unidade de medida recebida em Bytes para outras unidades
function formatFileSize(bytes) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const size = bytes / Math.pow(k, i);
  return `${size.toFixed(2)} ${sizes[i]}`;
}

export { currencyFormat, formatNumber, formatFileSize, currencyFormatStyleEnum }
